import PlayerFormModal from "./PlayerFormModal"

export function EditPlayerModal({ closeModal, playerData }) {
	return <PlayerFormModal mode="edit" closeModal={closeModal} playerData={playerData} />
}

export default EditPlayerModal
